import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function LoanSettings() {
  const [hours, setHours] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(false);

  const load = async () => {
    setLoading(true);
    setError(false);
    try {
      const { data } = await axios.get(`${API}/settings/loans`);
      setHours(String(data.overdue_hours));
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  const save = async (event) => {
    event.preventDefault();
    const value = Number(hours);
    if (!hours.trim() || !Number.isFinite(value) || value < 0.25 || value > 168) {
      toast.error("Bitte eine Zeit zwischen 0,25 und 168 Stunden eingeben.");
      return;
    }
    setSaving(true);
    try {
      const { data } = await axios.put(`${API}/settings/loans`, { overdue_hours: value });
      setHours(String(data.overdue_hours));
      toast.success("Ausleihzeit gespeichert");
    } catch {
      toast.error("Speichern fehlgeschlagen. Bitte erneut versuchen.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <main className="max-w-2xl mx-auto p-6 space-y-6">
      <Link to="/"><Button variant="outline">Zurück zum Dashboard</Button></Link>
      <Card>
        <CardHeader><CardTitle>Ausleihzeit festlegen</CardTitle></CardHeader>
        <CardContent>
          {loading ? <p>Einstellungen werden geladen …</p> : error ? (
            <div role="alert" className="space-y-3">
              <p>Einstellungen konnten nicht geladen werden.</p>
              <Button onClick={load}>Erneut versuchen</Button>
            </div>
          ) : (
            <form onSubmit={save} className="space-y-4">
              <Label htmlFor="overdue-hours">Als überfällig markieren nach (Stunden)</Label>
              <Input id="overdue-hours" type="number" min="0.25" max="168" step="any"
                required value={hours} disabled={saving}
                onChange={(event) => setHours(event.target.value)} />
              <p className="text-sm text-slate-600">
                Ab dieser Dauer nach der Ausgabe pulsiert das Gerätefeld rot.
                Die Einstellung gilt für alle Geräte, auch für laufende Ausleihen.
                Standard: 9 Stunden. Minimum: 15 Minuten. Maximum: 7 Tage.
              </p>
              <p className="text-sm text-slate-600">
                Das Dashboard übernimmt Änderungen spätestens bei seiner nächsten
                Aktualisierung nach 30 Sekunden. Das langsame Pulsieren bleibt bestehen.
              </p>
              <Button type="submit" disabled={saving}>{saving ? "Wird gespeichert …" : "Speichern"}</Button>
            </form>
          )}
        </CardContent>
      </Card>
    </main>
  );
}
